import React from 'react';
import { Link } from 'react-router-dom';
import styles from './LandingPage.module.css';
import ServiceCard from '../components/ServiceCard';
import { FaArrowRight, FaBrain, FaDatabase, FaCode, FaChartLine, FaCheckCircle, FaUserTie } from 'react-icons/fa'; // Added more icons

function LandingPage() {
  const calendlyLink = "https://calendly.com/talk2boardai"; // REPLACE with your actual Calendly link

  const services = [
    {
      iconType: 'ai-transformation',
      title: 'AI Transformation',
      bulletPoints: [
        'Crafting actionable AI roadmaps.',
        'Integrating cutting-edge AI solutions.',
        'Driving intelligent automation & insights.'
      ],
      iconComponent: FaBrain
    },
    {
      iconType: 'data-excellence',
      title: 'Data Excellence',
      bulletPoints: [
        'Building robust data architectures.',
        'Ensuring data quality & governance.',
        'Unlocking data-driven decision-making.'
      ],
      iconComponent: FaDatabase
    },
    {
      iconType: 'engineering-reliability',
      title: 'Engineering Reliability',
      bulletPoints: [
        'Developing scalable AI-driven platforms.',
        'Implementing agile & secure practices.',
        'Ensuring resilient system performance.'
      ],
      iconComponent: FaCode
    },
  ];

  const whyChooseUsPoints = [
    {
      icon: <FaUserTie />,
      title: 'Client-Centric Partnership',
      description: (
        <>
          Your success is our mission. We work collaboratively, offering tailored strategies and transparent communication to ensure <span className={styles.textPurple}>your unique business goals are met with precision</span>.
        </>
      ),
    },
    {
      icon: <FaCheckCircle />,
      title: 'Unwavering Data & Engineering Quality',
      description: (
        <>
          Our foundation is built on rigorous <span className={styles.textBlue}>data integrity and robust software engineering</span>. We deliver solutions that are not only innovative but also reliable, secure, and maintainable.
        </>
      ),
    },
    {
      icon: <FaBrain />,
      title: 'Future-Ready AI & Agentic Expertise',
      description: (
        <>
          Stay ahead in the agentic era. We bring deep expertise in generative AI and autonomous systems, guiding your transformation towards <span className={styles.textPurple}>smarter, more agile business operations</span>.
        </>
      ),
    },
  ];

  return (
    <div className={styles.landingPage}>
      {/* Hero Section */}
      <section className={styles.heroSection}>
        <div className={styles.heroContentLeft}>
          <h1>
            AI Transformation Through <br />
            <span className={styles.highlightPurple}>Solid Data and Software Engineering.</span>
          </h1>
          <p className={styles.heroSubheadline}>
            We build the robust data and engineering foundations that power your resilient and impactful AI.
          </p>
          <div className={styles.heroButtons}>
            <a href={calendlyLink} target="_blank" rel="noopener noreferrer" className="btn-primary">
              Book Free Consultation <FaArrowRight style={{ marginLeft: '10px' }} />
            </a>
            <Link to="/services" className="btn-secondary">
              View Our Services
            </Link>
          </div>
        </div>
      </section>

      {/* New Section for Services Tiles */}
      <section className={styles.servicesTilesSection}>
        {services.map((service, index) => (
          <ServiceCard
            key={index}
            iconComponent={service.iconComponent}
            title={service.title}
            bulletPoints={service.bulletPoints}
          />
        ))}
      </section>

      {/* Why Choose Us Section - Expanded Content */}
      <section className={styles.whyChooseUsSection}>
        <h2>Why Choose Talk2Board AI?</h2>
        <div className={styles.whyChooseGrid}>
          {whyChooseUsPoints.map((point, index) => (
            <div className={styles.whyChooseItem} key={index}>
              <div className={styles.whyChooseIcon}>{point.icon}</div>
              <h3>{point.title}</h3>
              <p>{point.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* (Other sections like Our Approach, Testimonials could follow here) */}
    </div>
  );
}

export default LandingPage;